module.exports = __webpack_public_path__ + "img/technology_icon_03.0cb05211.png";